<template>
  <v-container class="home without-padding" fluid fill-height>
      <div class="medium-div without-padding">
        <v-container class="without-padding container-img">
            <v-img :src="require('../assets/logoPonce.png')"/>
        </v-container>
        <div class="div-register-button" style="">
          <v-btn class="register-button" @click="signUpButton">Registrate con tu correo</v-btn>
        </div>
        <p class="sign-in-text">Ya tenes tu cuenta? <a class="sign-in-text" @click="signInButton"><u>Ingresa</u></a></p>
      </div>
    <div class="bottom-div">
      <p class="bottom-text">PONCE</p>
    </div>
  </v-container>
</template>

<script>
  export default {
    methods: {
      signUpButton () {
        this.$router.push({name: 'Signup'});
      },
      signInButton () {
        this.$router.push({name: 'Signin'});
      }
    }
  };
</script>




// WEBPACK FOOTER //
// Home.vue?73360898